import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { handleErrorMessage } from "../../../redux/actions/classes";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { getLLMQuizQuestions } from "../../../redux/actions/enhancedQuiz";
import TooltipWrapper from "../../CourseMonetization/Components/TooltipWrapper";

const QuizLLMInputModal = ({ open, onClose, data, paramsId }) => {
  const [formData, setFormData] = useState({
    topic: "",
    questionCount: "",
    preference: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { t } = useTranslation();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // const tempLLMResponse = [
  //   {
  //     id: "877405b4-19b3-450d-af67-678675e850f4",
  //     icon: "/Image/assignment/radio_button_checked.svg",
  //     type: "mcq",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText: 'What is the output of print(len("Python"))?',
  //     choices: [
  //       {
  //         id: "201a85e7-ccb2-4849-a923-15deab2bb60c",
  //         choiceText: "5",
  //         isCorrect: false,
  //       },
  //       {
  //         id: "ff3d16e6-88be-48e3-9596-0af2954c9b91",
  //         choiceText: "6",
  //         isCorrect: true,
  //       },
  //       {
  //         id: "dc244384-67eb-438b-8db7-84da9482c9e4",
  //         choiceText: "7",
  //         isCorrect: false,
  //       },
  //       {
  //         id: "ca5fb39a-0489-4772-90fa-30d7eb5532c3",
  //         choiceText: "None",
  //         isCorrect: false,
  //       },
  //     ],
  //   },
  //   {
  //     id: "e94a84f2-6cfc-49d4-879b-4038df5105ae",
  //     icon: "/Image/assignment/toggle_on.svg",
  //     type: "trueFalse",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText: "The Python interpreter is case-sensitive.",
  //     choices: [
  //       {
  //         id: "88e11005-b440-42ad-acdd-6d811f07c2bc",
  //         choiceText: "TRUE",
  //         isCorrect: true,
  //       },
  //       {
  //         id: "03b51583-fb74-468b-b67c-c7592530b7fa",
  //         choiceText: "FALSE",
  //         isCorrect: false,
  //       },
  //     ],
  //   },
  //   {
  //     id: "38455286-b5aa-4e14-9a88-1d0b07235efe",
  //     icon: "/Image/assignment/check_box.svg",
  //     type: "checkboxes",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText: "Which of the following are valid Python data structures?",
  //     choices: [
  //       {
  //         id: "d0393ce3-d419-4550-82c3-090513f3347b",
  //         choiceText: "Tuple",
  //         isCorrect: true,
  //       },
  //       {
  //         id: "54473927-ca69-4877-9be6-664d0f3fc48f",
  //         choiceText: "Set",
  //         isCorrect: true,
  //       },
  //       {
  //         id: "e624c527-fb8a-4005-b5da-4cd304834c04",
  //         choiceText: "Stack",
  //         isCorrect: false,
  //       },
  //       {
  //         id: "a25be0b2-1603-4c68-8384-eb0612a38ef8",
  //         choiceText: "Dictionary",
  //         isCorrect: true,
  //       },
  //     ],
  //   },
  //   {
  //     id: "3a3c1313-fea1-4548-8fd7-427a0bbf730e",
  //     icon: "/Image/assignment/apps.svg",
  //     type: "grid",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText: "Match the Python data types to their description:",
  //     choices: [
  //       {
  //         id: "071ff763-c6e5-42c2-9b6c-f3a3e26c54bc",
  //         choiceText: "List",
  //         correctChoice: "Ordered and mutable collection",
  //       },
  //       {
  //         id: "8c3e7a2a-8b55-4ba8-a2ef-beaf15aeb6c1",
  //         choiceText: "Tuple",
  //         correctChoice: "Ordered and immutable collection",
  //       },
  //       {
  //         id: "bd18220c-0a85-4bad-8d4a-cd37d779aba6",
  //         choiceText: "Dictionary",
  //         correctChoice: "Key-value pairs collection",
  //       },
  //       {
  //         id: "41b1bcc6-2139-4d22-978f-781d2426e388",
  //         choiceText: "Set",
  //         correctChoice: "Unordered collection of unique items",
  //       },
  //     ],
  //   },
  //   {
  //     id: "feeb1784-8839-4ae3-b1e9-c077814fb9ac",
  //     icon: "/Image/assignment/collections.svg",
  //     type: "imageChoice",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText: "Which of these images shows the Python logo?",
  //     choices: [
  //       {
  //         id: "59dba594-9576-4713-b832-c96d4810773e",
  //         choiceText:
  //           "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
  //         isCorrect: true,
  //         choiceImage: {},
  //       },
  //       {
  //         id: "53d836e9-7245-4e6e-96b6-44506cc55c53",
  //         choiceText:
  //           "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg",
  //         isCorrect: false,
  //         choiceImage: {},
  //       },
  //       {
  //         id: "cd416196-4c97-42e6-b0e6-9c50db8fbc32",
  //         choiceText:
  //           "https://upload.wikimedia.org/wikipedia/commons/7/74/Kotlin_Icon.png",
  //         isCorrect: false,
  //         choiceImage: {},
  //       },
  //       {
  //         id: "83077cd5-4b44-47ea-9224-40b746e31f67",
  //         choiceText:
  //           "https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg",
  //         isCorrect: false,
  //         choiceImage: {},
  //       },
  //     ],
  //   },
  //   {
  //     id: "43b7083e-a077-41cc-b186-a6723acf2433",
  //     icon: "/Image/assignment/short_text.svg",
  //     type: "shortAnswer",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText: "What keyword is used to create a class in Python?",
  //   },
  //   {
  //     id: "43bf292d-c500-431d-9af4-67ff0ff96107",
  //     icon: "/Image/assignment/view_headline.svg",
  //     type: "paragraph",
  //     isMandatory: true,
  //     maxMarks: 5,
  //     questionText:
  //       "Explain how Python's garbage collection works and how it helps manage memory.",
  //   },
  //   {
  //     id: "502c55bf-592f-4c8f-a333-53ace00859c3",
  //     icon: "/Image/assignment/horizontal_rule.svg",
  //     type: "fillInBlanks",
  //     isMandatory: true,
  //     maxMarks: 2,
  //     questionText:
  //       "In Python, the function used to read input from the user is _________.",
  //     choices: [
  //       {
  //         id: "5f3fe094-5257-4947-b3a1-6ad2be09b3b1",
  //         choiceText: "enhancedQuiz.blankAnswer",
  //         correctChoice: "input",
  //       },
  //     ],
  //   },
  // ];

  let lightning = "/Image/ai_quiz/lightning.svg";

  const handleGenerate = () => {
    console.log("Quiz Paris:", formData);
    if (formData.topic.trim() === "" || formData.questionCount.trim() === "" ) {
      dispatch(
      handleErrorMessage(t("errorMessageTranslations.requiredFields"))
      );
    } else if (parseInt(formData.questionCount) <= 0 || parseInt(formData.questionCount) > 25) {
      dispatch(
      handleErrorMessage("Number of questions must be greater than 0 and not more than 25")
      );
    } else {
      setIsLoading(true);
      dispatch(
      getLLMQuizQuestions({
        topic: formData.topic,
        number_of_questions: parseInt(formData.questionCount),
        type_of_questions: (isSelectAll || formData.preference.trim() === "") ? "mixed" :  formData.preference,
      })
      )
      .then(() => {
        setIsLoading(false);
        history.push({
        pathname: `/template/questions/${paramsId}`,
        state: {
          ...data,
          isAI: true,
        },
        });
      })
      .catch((error) => {
        setIsLoading(false);
        dispatch(handleErrorMessage(t("common.somethingWentWrong")));
        onClose();
        console.error("Error generating quiz:", error);
      });
    }};

  const questionTypes = [
    { value: "mcq", label: "Multiple Choice" },
    { value: "checkboxes", label: "Checkbox" },
    { value: "shortAnswer", label: "Short Answer" },
    { value: "paragraph", label: "Paragraph" },
    { value: "grid", label: "Grid" },
    { value: "fillInBlanks", label: "Fill in the Blank" },
    { value: "trueFalse", label: "True/False" },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "30px",
          padding: "1rem 1.5rem",
          paddingBottom: 0,
          maxWidth: "25%",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: "1.75rem",
          textAlign: "center",
        }}
      >
        Create Quiz with YuCampus AI
      </DialogTitle>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: "1rem",
          color: "#666666",
          mb: 2,
          fontWeight: 300,
          fontFamily: "Montserrat",
        }}
      >
        Let AI help you generate quizzes in seconds
      </Typography>

      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {isLoading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                zIndex: 1,
              }}
            >
              <img
                src={"/Image/ai_quiz/ai-loader.gif"}
                alt="Loading..."
                style={{ width: "30%" }}
              />
            </Box>
          )}

          <FormControl fullWidth>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 500,
                marginBottom: 1,
                fontSize: "1.125rem",
                color: "#170F49",
              }}
            >
              Quiz Topic
              <span style={{ color: "#ED1E24", marginLeft: "4px" }}>*</span>
            </Typography>
            <TextField
              name="topic"
              value={formData.topic}
              onChange={handleChange}
              placeholder="eg., Physics, World War II, Data Structures..."
              variant="standard"
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                "& .MuiInput-root": {
                  border: "1px solid rgb(239, 240, 247)",
                  borderRadius: "10px",
                  padding: "8px 12px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                  marginBottom: "1rem",
                },
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 500,
                marginBottom: 1,
                fontSize: "1.125rem",
                color: "#170F49",
              }}
            >
              Number of Questions
              <span style={{ color: "#ED1E24", marginLeft: "4px" }}>*</span>
            </Typography>
            <TextField
              name="questionCount"
              value={formData.questionCount}
              onChange={handleChange}
              type="number"
              variant="standard"
              placeholder="e.g., 5, 10, 20"
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                "& .MuiInput-root": {
                  border: "1px solid rgb(239, 240, 247)",
                  borderRadius: "10px",
                  padding: "8px 12px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                  marginBottom: "1rem",
                },
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 1, }}>
              <Typography
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: 500,
                  fontSize: "1.125rem",
                  color: "#170F49",
                }}
              >
                Quiz Preferences (Optional)
                {/* <span style={{ color: "#ED1E24", marginLeft: "4px" }}>*</span> */}
              </Typography>
              <TooltipWrapper title="Select the types of questions you want in your quiz. You can select multiple types or choose 'Select All' to include all types." placement="top-left">
                <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                  <AiOutlineInfoCircle size={22} />
                </span>
              </TooltipWrapper>
             
            </Box>
            <Box sx={{ 
              display: "grid", 
              gridTemplateColumns: "1fr 1fr", 
              gap: 1,
              alignItems: "start"
            }}>
              {questionTypes.map((type) => (
                <Box key={type.value} sx={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    checked={formData.preference.includes(type.value)}
                    onChange={(e) => {
                      const value = type.value;
                      const currentPreferences = formData.preference ? formData.preference.split(',') : [];
                      
                      if (e.target.checked) {
                        const newPreferences = [...currentPreferences, value];
                        setFormData({
                          ...formData,
                          preference: newPreferences.join(',')
                        });
                        // Check if all types are now selected
                        if (newPreferences.length === questionTypes.length) {
                          setIsSelectAll(true);
                        }
                      } else {
                        setFormData({
                          ...formData,
                          preference: currentPreferences.filter(pref => pref !== value).join(',')
                        });
                        
                        setIsSelectAll(false);
                      }
                    }}
                    sx={{
                      marginRight: "8px",
                      padding: "4px",
                      '&.Mui-checked': {
                        color: '#ED1E24',
                      },
                    }}
                  />
                  <Typography
                    component="label"
                    sx={{ 
                      fontFamily: "Montserrat", 
                      fontSize: "18px",
                      color: "#636363",
                      cursor: "pointer"
                    }}
                  >
                    {type.label}
                  </Typography>
                </Box>
              ))}

            </Box>


              {/* Select All checkbox */}
              <Box sx={{ display: "flex", alignItems: "center", marginTop: 1 }}>
                <Checkbox
                  checked={isSelectAll}
                  onChange={(e) => {
                    setIsSelectAll(e.target.checked);
                    if (e.target.checked) {
                      setFormData({
                        ...formData,
                        preference: questionTypes.map(type => type.value).join(','),
                      });
                    } else {
                      setFormData({
                        ...formData,
                        preference: ""
                      });
                    }
                  }}
                  sx={{
                    marginRight: "8px",
                    padding: "4px",
                    '&.Mui-checked': {
                      color: '#ED1E24',
                    },
                  }}
                />
                <Typography
                  component="label"
                  sx={{ 
                    fontFamily: "Montserrat", 
                    fontSize: "18px",
                    color: '#ed1e24',
                    cursor: "pointer",
                    fontStyle: "italic",
                  }}
                >
                  Select All
                </Typography>
              </Box>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{ flexDirection: "column", alignItems: "center", gap: 2 }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={handleGenerate}
          sx={{
            borderRadius: "0.625rem",
            backgroundColor: "#ED1E24",
            color: "white",
            fontFamily: "Montserrat",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            padding: "1rem",
            fontFamily: "Montserrat",
            fontSize: "1rem",
            textTransform: "capitalize",
            gap: 1,
            "&:hover": {
              backgroundColor: "#D71F24",
            },
          }}
        >
          Generate with AI
          <img
            src={"/Image/ai_quiz/lightning.svg"}
            alt="Lightning"
            style={{ width: "24px", height: "24px" }}
          />
        </Button>
        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "1rem",
            color: "#666666",
            fontFamily: "Montserrat",
            marginBottom: "1rem",
          }}
        >
          Powered by YuCampus
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default QuizLLMInputModal;
